export enum VaccinationState {
  NotFullyVaccinated,
  FullyVaccinated
}
